import { useEffect, useRef } from 'react';
import { SendIcon, StopIcon } from './Icons';

interface ComposerProps {
  value: string;
  busy: boolean;
  agentName: string;
  onChange: (value: string) => void;
  onSend: () => void;
  onStop: () => void;
}

export function Composer(props: ComposerProps) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    element.style.height = '0px';
    element.style.height = `${Math.min(element.scrollHeight, 160)}px`;
  }, [props.value]);

  return (
    <div className="composer-wrap">
      <div className="composer">
        <textarea
          ref={ref}
          value={props.value}
          onChange={(event) => props.onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing) {
              event.preventDefault();
              if (!props.busy) props.onSend();
            }
          }}
          placeholder={`Message ${props.agentName}…`}
          aria-label={`Message ${props.agentName}`}
          rows={1}
          disabled={props.busy}
        />
        {props.busy ? (
          <button className="send-button stop" type="button" onClick={props.onStop} aria-label="Stop run">
            <StopIcon />
          </button>
        ) : (
          <button
            className="send-button"
            type="button"
            onClick={props.onSend}
            disabled={!props.value.trim()}
            aria-label="Send message"
          >
            <SendIcon />
          </button>
        )}
      </div>
      <div className="composer-hint"><span>Enter to send</span><span>Shift + Enter for a new line</span></div>
    </div>
  );
}
